<template>
     <div class="col-md-12">
        <div class="col-md-12">
            <div class="row-table-title">
                    <div class="col-lg-12 col-xs-12 margin-tb row-table-background-purple" >
                        <div class="pull-left">
                            <h3 class="white-font  row-table-font-margins">{{ buildingName}}</h3>
                        </div>

                    </div>
                </div>
                <div class="clearfix" style="margin-top:35px;">
                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                        <router-link title="Committee" :to="{name:'committees',params:{buildingId:buildingId, buildingName:buildingName}}">Committee</router-link>
                    </div>
                </div>
                
                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                        <router-link title="@lang('strings.addnewexpensetype')"  :to="{name:'expensetypes',params:{buildingId:buildingId, buildingName:buildingName}}">Add new Expense Type</router-link>
                    </div>
                </div>

                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                        <router-link title="Service Providers" :to="{name:'suppliers',params:{buildingId:buildingId, buildingName:buildingName}}">Suppliers</router-link>
                    </div>
                </div>

                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                        <router-link title="Contacts" :to="{name:'contacts',params:{buildingId:buildingId, buildingName:buildingName}}">Contacts List</router-link>
                    </div>
                </div>

                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                    <a title="Monthly Fees" href="/">Monthly Fees</a>
                </div>
                </div>
                
                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                        <router-link title="Additional Expenses" :to="{name:'additionalindex',params:{buildingId:buildingId, buildingName:buildingName}}">Additional Expenses</router-link>
                    </div>
                </div>

                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                        <router-link title="c Expenses" :to="{name:'recurringexpenses',params:{buildingId:buildingId, buildingName:buildingName}}">Recurring Expenses</router-link>
                    </div>
                </div>
                
                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                        <router-link title="Additional Reports" :to="{name:'expensesbymonth',params:{buildingId:buildingId, buildingName:buildingName}}">Additional Reports</router-link>
                    </div>
                </div>

                <div class="more-column-circle">
                    <div class="more-column-circle-child">
                        <a title="Tutorials" href="/" >Tutorials</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
     data : function()  {
         return {
        //     buildingName: '',
             buildingId:0,
         }
    },
    mounted(){
    //    if(this.$route.params.buildingName)
     //      this.buildingName = this.$route.params.buildingName;
        if(this.$route.params.buildingId)
            this.buildingId = this.$route.params.buildingId;

    },
    computed:{
        ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    }
}
</script>